// removed by extract-text-webpack-plugin
module.exports = {"MapPoint":"MapPoint__MapPoint___1E6tX","disabled":"MapPoint__disabled___1JE8l","active":"MapPoint__active___3fjCm","warningActive":"MapPoint__warningActive___1S4Jk","warningSuccess":"MapPoint__warningSuccess___1gkcv","info":"MapPoint__info___L3R5y","approximate":"MapPoint__approximate___3jh5F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/MapPoint/MapPoint.scss
// module id = 1480
// module chunks = 0